.container {
    height: 100%;
    overflow: hidden;
    display: grid;
}
